"use strict";

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _setPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/setPrototypeOf");
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { var i = g[name]; if ("number" == typeof i) groups[name] = result[i];else { for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) k++; groups[name] = result[i[k]]; } return groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) { result.groups = buildGroups(result, this); var indices = result.indices; indices && (indices.groups = buildGroups(indices, this)); } return result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { var group = groups[name]; return "$" + (Array.isArray(group) ? group.join("$") : group); })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeStringParameter = exports.signatureToAbiDefinition = exports.parseDecodedParams = exports.getAbiByName = void 0;
var address_1 = require("@celo/base/lib/address");
/** @internal */
var getAbiByName = function getAbiByName(abi, methodName) {
  return abi.find(function (entry) {
    return entry.name === methodName;
  });
};
exports.getAbiByName = getAbiByName;
/** @internal */
var parseDecodedParams = function parseDecodedParams(params) {
  var args = new Array(params.__length__);
  Object.keys(params).forEach(function (key) {
    if (key === '__length__') {
      return;
    }
    var argIndex = parseInt(key, 10);
    if (argIndex >= 0) {
      args[argIndex] = params[key];
      delete params[key];
    }
  });
  return {
    args: args,
    params: params
  };
};
exports.parseDecodedParams = parseDecodedParams;
/** @internal */
var signatureToAbiDefinition = function signatureToAbiDefinition(fnSignature) {
  var matches = /*#__PURE__*/_wrapRegExp(/([^\(]+)\((.*)\)/, {
    method: 1,
    args: 2
  }).exec(fnSignature);
  if (matches == null) {
    throw new Error("".concat(fnSignature, " is malformed"));
  }
  var method = matches.groups.method;
  var args = matches.groups.args.split(',');
  return {
    name: method,
    signature: fnSignature,
    type: 'function',
    inputs: args.map(function (type, index) {
      var parts = type.trim().split(' ').map(function (p) {
        return p.trim();
      });
      if (parts.length > 2) {
        throw new Error("".concat(fnSignature, " is malformed"));
      }
      return {
        name: parts.length > 1 ? parts[1] : "a".concat(index),
        type: parts[0]
      };
    })
  };
};
exports.signatureToAbiDefinition = signatureToAbiDefinition;
/** @internal */
var decodeStringParameter = function decodeStringParameter(ethAbi, str) {
  return ethAbi.decodeParameter('string', (0, address_1.ensureLeading0x)(str));
};
exports.decodeStringParameter = decodeStringParameter;